
import React, { useEffect, useState} from 'react';

import {useTranslation} from 'react-i18next';
import NumberFormat from 'react-number-format';
import { Link } from 'react-router-dom';
import CustomSelect from '../../components/custom-select/CustomSelect';
import OperationModalWithDatatable from '../operation/OperationModalWithDatatable';
import UsedBomModalWithDatatable from './UsedBomModalWithDatatable';
import * as RestService from '../../services/eisRest';

const DocumentWorkOrderOperation = (props) => {


    const [t] = useTranslation();     
    const [operation, setItem] = useState(null);
    const [active, setActive] = useState(false);
    const [divideChecked, setDivideChecked] = useState(null);    
    const [workPositionList, setWorkPositionList] = useState([]);
    const [workPositionId, setWorkPositionId] = useState();
    const [resourceList, setResourceList] = useState([]);
    const [resourceId, setResourceId] = useState();
    const [bomId, setBomId] = useState(null);
    const [showOperationModalWithDatatable, setShowOperationModalWithDatatable] = useState(false);
    const [showUsedBomModalWithDatabase, setShowUsedBomModalWithDatabase] = useState(false);
   
 //   const [article, setArticle] = useState(null);
  
   

    const handleOpenOperationList = () => {
        setShowOperationModalWithDatatable(true);
      }
  

    const handleOpenBom = (e) => {
        setShowUsedBomModalWithDatabase(true);
    } 

    const handleCallbackOperationModalWithDatatable = (show,id) => {         
        setShowOperationModalWithDatatable(show);             
        getOperationData(id);
    };

    
    const handleCallbackUsedBomModalWithDatabase = (show,id) => {         
        setShowUsedBomModalWithDatabase(show);             
        //getOperationData(id);
    };
    
    const handleChangeDivide = () => {
        operation.divideAmongPcs = !operation.divideAmongPcs;
        setDivideChecked(operation.divideAmongPcs);
    };

    const callLoadWorkPosition = (id) => {
        RestService.callAnyApi('user/getWorkPosition?id='+id, null)
        .then((data) => {
                operation.workPositionId = data.id;
                operation.workPositionName = data.positionName;
                operation.costPerHourOperator = data.avgCostPerHour;                      
                recalcValues();
                callParent("update");
        })
        .catch((error) => {
          console.log(error);
        });
    }

    const callLoadResource = (id) => {
        RestService.callAnyApi('resource/getResource?id='+id, null)
        .then((data) => {
                operation.resourceId = data.id;
                operation.machineName = data.name;
                operation.costPerHourMachine = data.costPerHourOfWork;                         
                recalcValues();
                callParent("update");
        })
        .catch((error) => {
          console.log(error);
        });
    }

    const getOperationData = (id) => {
        RestService.callAnyApi('workOrder/getOperation?id='+id, null)
        .then((data) => {
       //   setArticle(data); 
      
        //  operation.id=data.id;       
            
          operation.name=data.name;         
          operation.nbr=data.nbr;
          operation.numOfMachines = data.numOfMachines;
          operation.durationMachine=data.durationMachine;
          operation.numOfOperators = data.numOfOperators;
          operation.durationOperator=data.durationOperator;
          operation.description = data.description;          
          operation.resourceId = data.resourceId;
          operation.divideAmongPcs = data.divideAmongPcs ? data.divideAmongPcs : false;
        
          setResourceId(data.resourceId);              
          if(data.resource!=null){            
            operation.machineName = data.resource.name;
            operation.costPerHourMachine = data.resource.costPerHourOfWork;
            operation.workPositionId = data.resource.workPositionId;
            setWorkPositionId(data.resource.workPositionId);                        
            if(data.resource.workPosition!=null){                
                operation.workPositionName = data.resource.workPosition.positionName;
                operation.costPerHourOperator = data.resource.workPosition.avgCostPerHour;
            }
          }
          recalcValues();
          callParent("update");
        })
        .catch((error) => {
          console.log(error);
        });
    }

    const recalcValues = () => {
        if(operation!=null){            

            operation.costMachine = ((operation.costPerHourMachine* operation.numOfMachines)/60) * operation.durationMachine;
            operation.costOperator = ((operation.costPerHourOperator* operation.numOfOperators)/60) * operation.durationOperator;

        }
    }

    useEffect(() => {      
        RestService.callAnyApi('resource/getResourceProductionSelectList', null).then((data) => { setResourceList(data);  }).catch((error) => {});      
        RestService.callAnyApi('user/getWorkPositions', null).then((data) => { setWorkPositionList(data);  }).catch((error) => {});      
    }, [])

 
    useEffect(() => {         
        setItem(props.operation);      
      //  getOperationData(props.operation.id);
    }, [props.operation])

    useEffect(() => {         
        setBomId(props.bomId);      
    }, [props.bomId])

    useEffect(() => {         
        setDivideChecked(props.divideAmongPcs);      
    }, [props.divideAmongPcs])
    

    useEffect(() => { 
        setActive(props.active);  
        if(props.active && operation){
            setResourceId(null);
            setResourceId(operation.resourceId);
            setWorkPositionId(null);
            setWorkPositionId(operation.workPositionId);
        }
    }, [props.active])

    

    const handleEdit = () => {        
        callParent("edit");
    }

    const handleCopy = () => {        
        callParent("copy");
    }

    const handleDelete = () => {        
        callParent("delete");
    }

    const callParent = (action) => {
        if(operation!=null){props.parentCallback(operation,action)}
    }

  

    const handleChange = (e,elementName) => {
      
        if(operation!=null){
            switch(elementName){
                case "name":
                    operation.operationName=e.target.value;   //text               
                break;
                case "nbr":
                    operation.nbr=e.value;    //number                       
                break;             
                case "numOfOperators":
                    operation.numOfOperators=e.value;    //number        
                    recalcValues();                  
                break;  
                case "numOfMachines":
                    operation.numOfMachines=e.value;    //number                       
                    recalcValues();   
                break;  
                case "durationMachine":
                    operation.durationMachine=e.floatValue;    //number 
                    recalcValues();                      
                break;             
                case "durationOperator":
                    operation.durationOperator=e.floatValue;    //number   
                    recalcValues();                       
                break;             
                case "costMachine":
                    operation.costMachine=e.floatValue;    //number                       
                    recalcValues();   
                break;    
                case "costOperator":
                    operation.costOperator=e.floatValue;    //number                       
                    recalcValues();   
                break;                      
                case "description":
                    operation.description=e.target.value;   //text               
                break;
            }
            callParent("update")
        }
    };

   
   
    return (

               <>                 
                    <div className="row" style={{borderRadius: '5px'}}>
    					  	      					  	  
                            <div className="col-12 col-sm-12 col-lg-12">

                                    <div className="row">

                                        <div className="col-3 col-sm-3 col-lg-3" >
  
                                                <span style={!active ? { paddingTop: '15px', fontWeight: 'bold'} : { display: 'none' }} >{operation ? operation.name : ""}</span>
                                                <div className="input-group mb-3 find-operation" style={active ? {} : { display: 'none' }}>
                                                        <div className="input-group-prepend">
                                                                <span className="input-group-text"><i className="fa fa-search"></i></span>
                                                        </div>
                                  
                                                        <input type="text"  className="form-control col-12 col-sm-12 col-lg-12" placeholder={t('workOrder.label.findOperation') } readOnly onClick={handleOpenOperationList} value={operation ? operation.name : ""} onChange={(e) => {handleChange(e,"name")}}/>
                                                </div>
                                        </div>                                          

                                        <div className="col-1 col-sm-1 col-lg-1">
                                                                                             
                                                <NumberFormat displayType={active ? 'input' : 'text'}  className="form-control col-12 col-sm-12 col-lg-12"  decimalScale="0"  style={active ? {} : { background: '#E9ECEF' }} value={operation ? operation.nbr : 0} onValueChange={(values)  => {handleChange(values,"nbr")}} />                                                
                                        </div>
                                      

                                        <div className="col-1 col-sm-1 col-lg-1">
    
                                                <NumberFormat displayType={active && operation.resourceId ? 'input' : 'text'}  className="form-control col-12 col-sm-12 col-lg-12" decimalScale="0" thousandSeparator="." decimalSeparator=","   style={active ? {} : { background: '#E9ECEF' }} value={operation ? operation.numOfMachines : 1} onValueChange={(values)  => {handleChange(values,"numOfMachines")}} />                                                
                                        
                                        </div>

                                        <div className="col-1 col-sm-1 col-lg-1">
    
                                                <NumberFormat displayType={active ? 'input' : 'text'}  className="form-control col-12 col-sm-12 col-lg-12" decimalScale="1" thousandSeparator="." decimalSeparator=","  suffix={' min.'} style={active ? {} : { background: '#E9ECEF' }} value={operation ? operation.durationMachine : 0} onValueChange={(values)  => {handleChange(values,"durationMachine")}} />                                                
                                        
                                        </div>

                                        <div className="col-1 col-sm-1 col-lg-1">
    
                                                 <NumberFormat displayType="text"  className="form-control col-12 col-sm-12 col-lg-12" decimalScale="1" thousandSeparator="." decimalSeparator=","  suffix={' €'}  style={active ? {} : { background: '#E9ECEF' }} value={operation ? operation.costMachine : 0} onValueChange={(values)  => {handleChange(values,"costMachine")}} />                                                
                                                
                                        </div>

                                      

                                        <div className="col-1 col-sm-1 col-lg-1">
    
                                                <NumberFormat displayType={active  && operation.workPositionId ? 'input' : 'text'}  className="form-control col-12 col-sm-12 col-lg-12" decimalScale="0" thousandSeparator="." decimalSeparator=","   style={active ? {} : { background: '#E9ECEF' }} value={operation ? operation.numOfOperators : 1} onValueChange={(values)  => {handleChange(values,"numOfOperators")}} />                                                

                                        </div>

                                        <div className="col-1 col-sm-1 col-lg-1">
    
                                                 <NumberFormat displayType={active ? 'input' : 'text'}  className="form-control col-12 col-sm-12 col-lg-12" decimalScale="1" thousandSeparator="." decimalSeparator="," suffix={' min.'} style={active ? {} : { background: '#E9ECEF' }} value={operation ? operation.durationOperator : 0} onValueChange={(values)  => {handleChange(values,"durationOperator")}} />                                                

                                        </div>

                                        <div className="col-1 col-sm-1 col-lg-1">

                                                 <NumberFormat  displayType="text"  className="form-control col-12 col-sm-12 col-lg-12" decimalScale="1" thousandSeparator="." decimalSeparator="," suffix={' €'} style={active ? {} : { background: '#E9ECEF' }} value={operation ? operation.costOperator : 0} onValueChange={(values)  => {handleChange(values,"costOperator")}} />                                                
                                            
                                        </div>

                                        <div className="col-1 col-sm-1 col-lg-1" style={{"marginTop" : "10px" }}>

                                        <input
                                                type="checkbox"
                                                checked={divideChecked}                                                
                                                onChange={handleChangeDivide}
                                        />

                                        </div>
                                        
                                      
                                                                                          
                                                <div className="col-1 col-sm-1 col-lg-1"  style={operation && operation.id!=='' ? {  } : { display: 'none' }} >
                                                
                                                    <i className="fa fa-times fa-sm remove-operation" title={t('document.label.removeItem')} style={{marginTop: '15px', marginRight: '10px',color: '#FF0000'}} onClick={handleDelete}></i>
                                                    <i className="fas fa-copy fa-sm copy-operation" title={t('document.label.copyItem')} style={{marginTop: '15px',marginRight: '10px',color: '#007BFF'}} onClick={handleCopy}></i>
                                                    <i className="far fa-edit fa-sm edit-operation" title={t('document.label.editItem')}  style={{marginTop: '15px',marginRight: '10px',color: '#469623'}} onClick={handleEdit}></i>
                                                    <Link to='#' style={{ fontWeight: 'bold' }} onClick={handleOpenBom} >{t('workOrder.label.bom')}</Link>

                                                </div>
                                                
                                        </div>


                                        <div className="row" style={{marginTop: '1px'}}>

                                                <div className="col-3 col-sm-3 col-lg-3">
                                            
                                                        <span style={!active ? { fontSize: '14px' } : { display: 'none' }}>{operation ? operation.machineName : ""}</span>                                                                                                      
                                                        <CustomSelect
                                                           className={active ? 'input' :  'd-none' }   
                                                            name="resourceId"                                                           
                                                            onChange={(opt, e) => {                                             
                                                                setResourceId(opt.value); 
                                                                operation.resourceId = opt.value; 
                                                                callLoadResource(opt.value);
                                                            }}
                                                            value={resourceId ? 
                                                                resourceId : ''
                                                            }
                                                            options={resourceList}     
                                                        />                          
                                               </div> 
                                       
                                               <div className="col-3 col-sm-3 col-lg-3">
                                               
                                               
                                               </div>
                                        </div>

                                        <div className="row" style={{marginTop: '1px'}}>

                                                    <div className="col-3 col-sm-3 col-lg-3">
                                                            
                                                            <span style={!active ? { fontSize: '14px' } : { display: 'none' }}>{operation ? operation.workPositionName : ""}</span>                                                                                                      
                                                            <CustomSelect
                                                                    className={active ? 'input' :  'd-none' }   
                                                                    name="workPositionId"                                                                   
                                                                    onChange={(opt, e) => {                                             
                                                                        setWorkPositionId(opt.value);
                                                                        operation.workPositionId = opt.value;
                                                                        callLoadWorkPosition(opt.value);
                                                                    }}
                                                                    value={workPositionId ? workPositionId : ''}
                                                                    options={workPositionList}     
                                                                />           
                                                    </div>        
                                       
                                        </div>

                                        <div className="row" style={{marginTop: '3px'}}>

                                                <div className="col-12 col-sm-12 col-lg-12">
                                                    
                                                    <span style={!active ? { fontSize: '14px', fontStyle: 'italic' } : { display: 'none' }}>{operation ? operation.description : ""}</span>                                                                                                      
                                                    <textarea className="form-control  col-12 col-sm-12 col-lg-12" 
                                                                rows="3"
                                                                name="description"
                                                                style={active ? {} : { display: 'none' }}                                                                
                                                                onChange={(e) => {handleChange(e,"description")}} 
                                                                placeholder={t('workOrder.label.operationDescription')} 
                                                                value={operation ? operation.description : ""}></textarea>
                                                                    
                                                </div>                                                                                  
                                                <div className="col-2 col-sm-2 col-lg-2"></div>	

                                        </div>

                                     
                            </div>

                    </div>
                
                
                    <OperationModalWithDatatable            
                          parentCallback={handleCallbackOperationModalWithDatatable}    
                          modal={showOperationModalWithDatatable}                                
                    />

                    <UsedBomModalWithDatatable
                             modal={showUsedBomModalWithDatabase}
                             parentCallback={handleCallbackUsedBomModalWithDatabase}
                             workOrderId={operation ? operation.workOrderId : ''}                      
                             operationId={operation ? operation.id : ''}                      
                             bomId={bomId}     
                             edit={true}  
                   />

                </>
                   
    );

}

export default DocumentWorkOrderOperation;